// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","commonButton":"_3_TJK","reversedColor":"_1H4MQ"};